function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18">
      <path fill="currentColor" d="m14 11-7 7-7-7ZM0 7l7-7 7 7Z" />
    </svg>
  );
}

export default Icon;
